import axios from 'axios';
import { TAGS_LIST } from '../paths';

export const getTagsList = async () => {
  const response = await axios.get(TAGS_LIST);
  const results = response.data;
  return results;
};
